import { Link } from 'react-router-dom';
import { disclaimer, site } from '../config';
import { navLinks } from '../data';

const legalLinks = [
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/terms-of-service', label: 'Terms of Service' },
  { to: '/refund-policy', label: 'Refund Policy' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="wrap footer-grid">
        <div>
          <p className="footer-brand">{site.brand}</p>
          <p className="footer-text">
            Friendly, independent help for Family Tree Maker users — installs, sync, upgrades, and moves to a new
            computer.
          </p>
        </div>

        <div>
          <h3 className="footer-title">Explore</h3>
          <ul className="footer-list">
            {navLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="footer-title">Policies</h3>
          <ul className="footer-list">
            {legalLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="footer-title">Reach Us</h3>
          <ul className="footer-list">
            <li>
              <a href={site.phoneHref}>Phone: {site.phone}</a>
            </li>
            <li>
              <a href={`mailto:${site.email}`}>{site.email}</a>
            </li>
            <li>{site.hours}</li>
          </ul>
        </div>
      </div>

      <div className="wrap footer-base">
        <p className="footer-disclaimer">
          <strong>Disclaimer:</strong> {disclaimer}
        </p>
        <p>
          &copy; {new Date().getFullYear()} {site.domain}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
